<template>

    <FloatingPanel>

        <div class="event::canvas-blocks-modules-events-BlockPanel">

            <CommonInputs
                :options="options"
            />

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput,
    },

}

</script>
